import { makeEnumClass } from '../base-enum';

export class SituacaoFuncionalEnum extends makeEnumClass() {
    static readonly CLT = SituacaoFuncionalEnum.add('CLT', 'CLT');
    static readonly ANISTIADO = SituacaoFuncionalEnum.add('ANS', 'Anistiado');
    static readonly ESTATUTARIO = SituacaoFuncionalEnum.add('EST', 'Estatuário');
    static readonly CONTRATO_TEMPORARIO = SituacaoFuncionalEnum.add('CDT', 'Contrato Temporário');
    static readonly NATUREZA_ESPECIAL = SituacaoFuncionalEnum.add('NES', 'Natureza Especial');
}
